declare global {
  interface Window {
    umbEngage?: (
      command: string,
      hitType: string,
      category: string,
      action: string,
      label: string
    ) => void;
  }
}

const ENGAGE_CATEGORY = 'Homepage Search Input AB' as const;

const sendEngageEvent = (category: string, action: string, label: string): void => {
  // window.umbEngage loads after Cookiebot consent — null-check before calling.
  if (typeof window.umbEngage === 'function') {
    window.umbEngage('send', 'event', category, action, label);
  }
};

// Secondary/diagnostic goal: user interacts with the search input (variant B only).
export const homepageSearchInteract = (): void => {
  sendEngageEvent(ENGAGE_CATEGORY, 'search_interact', '');
};

// Primary/decision goal: user submits the search form (fires from both variants).
export const homepageSearchSubmit = (): void => {
  sendEngageEvent(ENGAGE_CATEGORY, 'search_submit', '');
};

// Primary metric: user begins the checkout flow (attributed to the variant's segment).
export const homepageSearchCheckoutBegin = (): void => {
  sendEngageEvent(ENGAGE_CATEGORY, 'checkout_begin', '');
};

// Primary metric: booking / conversion completed.
export const homepageSearchPurchaseComplete = (bookingType: 'paid' | 'reserved'): void => {
  sendEngageEvent(ENGAGE_CATEGORY, 'purchase_complete', bookingType);
};

// Initialises DOM-listener tracking for variant A (read-only search button).
// Called from main.js domReady. The button carries data-ab-homepage-search-input so
// Engage tracks the search_submit goal when the user clicks through to the modal.
export const initHomepageSearchInputABTesting = (): void => {
  const el = document.querySelector('[data-ab-homepage-search-input]');
  if (!el) {
    return;
  }

  el.addEventListener('click', () => {
    homepageSearchSubmit();
  });
};
